export default __webpack_public_path__ + "static/multicolor-woman-with-map-eaf91e861854e95b26577342258d1b56.svg";